import {
  CREATE_CONTACT
} from "../type";

const inital = {
  Createcontactus: [],
  loading: true,
  error:[]
};
const ContactusReduser = (state = inital, action) => {
  switch (action.type) {
    case CREATE_CONTACT:
      return {
        Createcontactus: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default ContactusReduser;
